import { schemes } from "@zeal/common";
import { z } from "zod";

export const getFurtherActionNoticeURLsByWorkerIDsRequestSchema = z.object({
  companyID: schemes.companyID(),
  testMode: z.boolean(),
  workerIDs: z.array(schemes.mongoObjectId()).min(1),
});

export const getFurtherActionNoticeURLsByWorkerIDsResponseSchema = z.object({
  urls: z.array(
    z.object({
      workerID: schemes.mongoObjectId(),
      url: z.string().nullish(),
    })
  ),
});

export type TGetFurtherActionNoticeURLsByWorkerIDsRequest = z.infer<
  typeof getFurtherActionNoticeURLsByWorkerIDsRequestSchema
>;

export type TGetFurtherActionNoticeURLsByWorkerIDsResponse = z.infer<
  typeof getFurtherActionNoticeURLsByWorkerIDsResponseSchema
>;
